// Small pub/sub, same pattern as gameReset.ts and settings.ts's onSpriteIdChange:
// ui.ts (which has no reference to the Phaser scene) fires this on every Measure
// cast, radial or not, and GameScene listens to paint the actual visual. Despite
// the file name (kept to avoid an unrelated rename), this now covers both the
// area sweep (Radial) and the single faced-tile case (no Radial modifier) --
// `radial` distinguishes which, and `radiusTiles` only means anything when it's
// true.
import { ConceptId } from '../../rune-lab/src/runes/concepts';

export interface RadialMeasureEvent {
  conceptId: ConceptId;
  radial: boolean;
  radiusTiles: number;
}

const listeners: Array<(event: RadialMeasureEvent) => void> = [];

export function onRadialMeasure(listener: (event: RadialMeasureEvent) => void): void {
  listeners.push(listener);
}

export function triggerRadialMeasure(event: RadialMeasureEvent): void {
  listeners.forEach((listener) => listener(event));
}
